import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill, BsTelephoneOutboundFill } from "react-icons/bs";

const SocialLinks = () => {
  const handleResumeDownload = () => {
    const resumeURL =
      "https://drive.google.com/file/d/135kRCX_6ceX2hohmOELduZRr9liELGUp/view?usp=sharing";
    window.open(resumeURL, "_blank");
  };

  return (
    <div className="hidden flex-col top-[35%] left-0 fixed lg:flex">
      <ul>
        <li
          id="contact-linkedin"
          className="flex justify-between items-center w-44 h-14 px-4 ml-[-118px] hover:ml-[-5px] hover:rounded-md duration-300 bg-gray-500 rounded-tr-md"
        >
          <a
            href="https://www.linkedin.com/in/gauravshukla82/"
            target="_blank"
            className="flex justify-between items-center w-full text-white"
          >
            LinkedIn <FaLinkedin size={30} />
          </a>
        </li>
        <li
          id="contact-github"
          className="flex justify-between items-center w-44 h-14 px-4 ml-[-118px] hover:ml-[-5px] hover:rounded-md duration-300 bg-gray-500"
        >
          <a
            href="https://github.com/Gauravshukla82"
            target="_blank"
            className="flex justify-between items-center w-full text-white"
          >
            GitHub <FaGithub size={30} />
          </a>
        </li>
        <li
          id="contact-email"
          className="flex justify-between items-center w-44 h-14 px-4 ml-[-118px] hover:ml-[-5px] hover:rounded-md duration-300 bg-gray-500"
        >
          <a
            href="mailto:gauravshukla.ec1022@gmail.com"
            target="_blank"
            className="flex justify-between items-center w-full text-white"
          >
            Mail <HiOutlineMail size={30} />
          </a>
        </li>
        <li
          id="resume-button-2"
          className="flex justify-between items-center w-44 h-14 px-4 ml-[-118px] hover:ml-[-5px] hover:rounded-md duration-300 bg-gray-500"
        >
          <a
            href="/Gaurav-Shukla-Resume.pdf"
            className="flex justify-between items-center w-full text-white"
            download
            onClick={handleResumeDownload}
            id="resume-link-2"
          >
            Resume <BsFillPersonLinesFill size={30} />
          </a>
        </li>
        <li
          id="contact-phone"
          className="flex justify-between items-center w-44 h-14 px-4 ml-[-118px] hover:ml-[-5px] hover:rounded-md duration-300 bg-gray-500 rounded-br-md"
        >
          <a
            href="/"
            className="flex justify-between items-center w-full text-white"
          >
            7376603602 <BsTelephoneOutboundFill size={26} />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SocialLinks;
